// extracted by mini-css-extract-plugin
module.exports = {"container":"UnavailableCreative-container--7Vtc6","text":"UnavailableCreative-text-1dZQ2d","tooltipContainer":"UnavailableCreative-tooltipContainer-3wi4LH"};